import { Link, Typography } from "@mui/material"
import { SOL, USDC } from "@renec-foundation/relend-adapter"

const locale: { [key: string]: any } = {
  base: {
    all_rights_reserved: "Đã đăng ký bản quyền",
    relend_all_rights_reserved: "RENEC Lend đã đăng ký bản quyền",
  },
  header: {
    vietnamese: "Tiếng việt",
    english: "English",
    home: "Trang Chủ",
    create_token: "Tạo Token",
    faqs: "FAQs",
    connect_wallet: "Kết nối ví Demon",
    dashboard: "Bảng tổng hợp",
    liquidations: "Thanh lý vay",
    referral: "Giới thiệu bạn bè",
    docs: "Tài liệu",
    audits: "Kiểm định",
    tokenomic: "Tokenomic",
    staking: "Staking",
    tokenomic_link: "https://renec.org/blog/tokenomics-relend-token-vi",
    audit_link: "https://renec.org/vi/blog/hoan-tat-kiem-dinh-hop-dong-thong-minh-renec-lend",
  },
  footer: {
    about_us: "Về chúng tôi",
    news: "Tin tức",
    faq: "FAQ",
    career: "Công việc",
    contact: "Liên hệ",
    privacy: "Chính sách bảo mật",
    terms: "Điều khoản & Sử dụng",
  },
  seo: {
    seo_title: "RENEC Lend | Website Chính Thức",
    seo_title_dashboard: "RENEC Lend | Quản Lý Tài Khoản",
    seo_title_referral: "RENEC Lend | Chương Trình Giới Thiệu",
    seo_title_liquidations: "RENEC Lend | Khoản Vay Bị Thanh Lý",
    seo_title_staking: "RENEC Lend | Staking",
    seo_description:
      "Dịch vụ cho vay & cho vay với RENEC Lend. An toàn & Lãi suất tốt. Cơ hội kiếm thêm thu nhập thụ động",
    seo_description_dashboard:
      "Dịch vụ cho vay & cho vay với RENEC Lend.Tính thanh khoản tốt và đa dạng tùy chọn token",
    seo_description_referral:
      "Mời bạn bè tham gia sử dụng dịch vụ Vay & Cho vay của RENEC Lend để có cơ hội nhận những ưu đãi độc quyền",
    seo_description_liquidations:
      "Theo dõi các khoản vay đang bị thanh lý và tìm kiếm cơ hội trở thành liquidator với mức thu nhập hấp dẫn",
    seo_description_staking:
      "Stake tài sản vào Secure Vault của RENEC Lend để tăng thêm tính bảo mật cho giao thức và kiếm phần thưởng",
  },
  home: {
    title_p1: "RENEC Lend: Vay và Cho vay",
    title_p2: "Kiếm lợi nhuận ngay",
    sub_title: (
      <>
        Kiếm lợi nhuận cạnh tranh và vay tiền mặt dễ dàng trên <span className='font-bold'>RENEC Lend</span>, giao thức
        cho vay tiền mặt nhanh nhất, phí thấp nhất và an toàn nhất.
      </>
    ),
    get_started: "Bắt đầu",
    become_liquidator_p1:
      "Hãy trở thành một trong những Liquidator sớm nhất, và tận hưởng cơ hội kiếm thêm lợi nhuận chỉ có trong đợt ra mắt sớm. Cơ hội chỉ đến với",
    become_liquidator_p2: "đăng ký đầu tiên. Đăng ký ngay và nhận ưu đại hấp dẫn! Liquidator là gì?",
    exclusive_slots: "1,000 người",
    what_is_liquidator: "Liquidator là gì?",
    liquidator: "LIQUIDATOR",
    liquidators: "LIQUIDATORS",
    registration: "Trở thành",
    email: "Email",
    register: "Đăng ký",
    invalid_email: "Địa chỉ email không hợp lệ",
    days: "Ngày",
    hours: "Giờ",
    minutes: "Phút",
    seconds: "Giây",
    why_choose_p1: "Bạn chọn",
    renec_land: "RENEC Lend",
    why_choose_p2: "vì?",
    trustworthy_protocal: "Giao thức đáng tin cậy:",
    trustworthy_protocal_description:
      "Chúng tôi được hỗ trợ bởi RENEC Foundation, đảm bảo các tiêu chuẩn an ninh cao nhất nhằm mang lại sự yên tâm cho bạn.",
    lower_interest: "Lãi Suất Thấp:",
    lower_interest_description:
      "Bạn được hưởng lãi suất cạnh tranh nhất nhằm đảm bảo thu nhập của mình được trọn vẹn hơn.",
    user_focused: "Hướng đến người dùng:",
    user_focused_description: "Chúng tôi cam kết mang đến trải nghiệm tốt nhất có thể cho tất cả người dùng.",
    simplicity: "Đơn Giản",
    simplicity_subtitle: "Dễ dàng tiếp cận với cả người mới bắt đầu hoặc chuyên gia.",
    economy: "Hiệu Quả ",
    economy_subtitle: "Đảm bảo bạn có thể tận dụng tối ưu tài sản crypto của mình trên RENEC Blockchain.",
    opportunity: "Cơ hội",
    opportunity_subtitle:
      "Mang cơ hội trở thành Liquidator cho tất cả mọi người thông qua chương trình của chúng tôi.  ",
    join_mail: "đăng kí nhận tin từ chúng tôi",
    im_in: "Tôi tham gia",
    email_submit_success: "Email gửi thành công",
    what_is_liquidator_tooltip:
      "Liquidator là một cá nhân hoặc tổ chức tận dụng các cơ hội khi khoản vay của người dùng khác đạt đến ngưỡng thanh lý do biến động của thị trường. Họ trả nợ của người đi vay và đổi lại nhận được một phần tài sản thế chấp của người đi vay với lãi suất chiết khấu.",
    launch_app: "Mở ứng dụng",
    why_choose_we: "Tại sao chọn chúng tôi",
    feedback: "Phản hồi",
    snapshot_of_our_success: "Thành tựu của chúng tôi",
    explore_analytics:
      "Renec Lend là tương lai của cho vay tiền mặt, mang đến khả năng tiếp cận, hiệu quả, an toàn và đổi mới vượt trội.",
    trusted_by_our_investors: "Được các nhà đầu tư của chúng tôi tin cậy",
    understanding_renec_lend: "Hiểu về Renec Lend",
    discover_the_key_functions:
      "Khám phá các chức năng chính của Renec Lend để tối ưu hóa lợi nhuận và quản lý tài sản hiệu quả.",
    understanding_details: {
      tabs: [
        {
          title: "Cung cấp để kiếm tiền",
          description: "Cung cấp tài sản của bạn lên nền tảng để kiếm lãi và nhận thưởng airdrop.",
        },
        {
          title: "Voucher NFT",
          description: "Nhận voucher NFT độc quyền để giảm phí và lãi vay.",
        },
        {
          title: "Token Relend",
          description: "Tham gia cộng đồng của chúng tôi và định hình tương lai của DeFi với token REL.",
        },
        {
          title: "Staking",
          description: "Kiếm lợi nhuận và các ưu đãi độc quyền từ token REL của bạn.",
        },
      ],
      details: [
        {
          title: "Cung cấp để kiếm tiền",
          description:
            "Cung cấp tài sản cho giao thức để kiếm lãi và phần thưởng. Chúng tôi luôn hợp tác với các dự án tiềm năng để mang đến những airdrop hấp dẫn nhất cho người dùng.",
          items: [],
          note: "",
        },
        {
          title: "Voucher NFT",
          description:
            "Voucher NFT là tài sản kỹ thuật số độc đáo cung cấp cho người sở hữu các lợi ích đặc quyền như giảm phí và lãi suất trên nền tảng cho vay DeFi của chúng tôi. Trải nghiệm sức mạnh của voucher NFT và mở khóa thế giới tiết kiệm ngay hôm nay.",
          items: [],
          note: "",
        },
        {
          title: "Token Relend",
          description: (
            <>
              Token{" "}
              <a
                href='https://solscan.io/token/9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV'
                target='_blank'
                rel='noreferrer'
                className='text-blue-600 underline'
              >
                Relend (REL)
              </a>{" "}
              là token quản trị của nền tảng cho vay DeFi của chúng tôi, trao quyền cho người sở hữu để định hình tương
              lai của giao thức và nhận các lợi ích thành viên độc quyền.
            </>
          ),
          items: [],
          note: "",
        },
        {
          title: "Staking",
          description:
            "Bằng cách staking token Relend, người dùng có thể tham gia vào các quyết định quản trị như đề xuất và bỏ phiếu cho các tính năng mới, nâng cấp, và thay đổi của nền tảng. Ngoài ra, người staking còn có thể nhận phần thưởng từ kho bạc của giao thức.",
          items: [],
          note: "",
        },
      ],
    },
    why_choose_renec_lend: "Tại sao chọn Renec Lend?",
    backed_by_renec_foundation:
      "Được hỗ trợ bởi Quỹ RENEC, Renec Lend cung cấp các khoản vay an toàn, lãi suất cạnh tranh",
    renec_lend_insights: "Thông tin chi tiết về Renec Lend",
    stay_informed_with_the_latest_news:
      "Cập nhật các tin tức mới nhất, mẹo và thông tin về cho vay crypto. Khám phá cách tối đa hóa lợi nhuận và điều hướng thế giới tài chính phi tập trung với Renec Lend.",
    stay_updated_with_renec_lend: "Luôn cập nhật với Renec Lend",
    join_with_your_email: "Tham gia với email của bạn để nhận tin tức, phần thưởng và nhiều hơn nữa!",
    join_now: "Tham gia ngay",
    enter_your_email: "Nhập email của bạn",
    discover_now: "Khám phá ngay",
    first_fiat_lending_protocol: "Giao thức Cho vay Tiền mặt Đầu tiên",
    introducing_our_revolutionary:
      "Giới thiệu nền tảng Cho vay Tiền mặt cách mạng: nền tảng đầu tiên và duy nhất cung cấp các khoản vay tiền mặt an toàn, minh bạch và dễ tiếp cận.",
    lower_nterest_rates: "Lãi Suất Thấp Hơn",
    we_offers_the_most: "Chúng tôi cung cấp lãi suất cạnh tranh nhất để đảm bảo bạn giữ lại nhiều lợi nhuận hơn",
    liquidity_mining_with_airdrop: "Khai thác Thanh khoản với Airdrop",
    earn_rewards_by_providing:
      "Kiếm phần thưởng bằng cách cung cấp thanh khoản cho các pool của chúng tôi và nhận airdrop độc quyền từ các đối tác.",
    total_supply: "Tổng ký gửi",
    total_borrow: "Tổng vay",
    unique: "Unique wallets",
    mentioned_by: "Được nhắc đến trong",
  },
  dashboard: {
    hero: {
      market_overview: "Tổng quan thị trường",
      renec_market: "Thị trường Renec",
      solana_market: "Thị trường Solana",
      new: "Mới",
      select_market: "Chọn thị trường",
      total_supply: "Tổng kí gửi",
      total_borrow: "Tổng tiền vay",
      total_tvl: "TVL",
      total_market: "Tổng thị trường",
      account_overview: "Tài sản của tôi",
      net_apy: "APY trung bình",
      user_borrow_limit: "Hạn mức vay",
      liquidation_threshold: "Ngưỡng thanh lý",
      current_progress_title: "Bạn đang mượn %s% tổng kí gửi của bạn, hoặc %s% hạn mức của bạn",
      borrow_limit_title: "Hạn mức mượn của bạn là %s và chiếm %s% tổng kí gửi của bạn",
      liquidation_threshold_title: "Ngưỡng thanh lý của bạn là %s và chiếm %s% tổng kí gửi của bạn",
      supply_title: "Tổng kí gửi của bạn là %s. Hãy kí gửi thêm tài sản để tăng hạn mức vay và ngưỡng thanh lý.",
      daily_reward: "Phần thưởng hàng ngày",
      claim: "Nhận ngay",
      borrow_at_least: "Để nhận phần thưởng hàng ngày, bạn cần vay ít nhất: ",
      level_1: "LVL1. $100 để nhận 0.1 REL/ngày",
      level_2: "LVL2. $200 để nhận 0.5 REL/ngày",
      level_3: "LVL3. $500 để nhận 2 REL/ngày",
      level_4: "LVL4. $1000 để nhận 2.5 REL/ngày",
      level_5: "LVL5. Với mỗi $1,000 bạn vay thêm, bạn sẽ kiếm được 0.5 REL",
      claim_successfully: "Nhận thưởng thành công.",
      come_back_at: "Quay lại vào ",
      left: "Còn",
      to_claim: "để nhận",
      to_claim_more: "để nhận thêm",
      for_more_reward: "để nhận thưởng nhiều hơn",
      reward_will_be_accumulated: "Phần thưởng sẽ được cộng dồn.",
      errors: {
        refresh_reward: "Lỗi khi cập nhập khoản thưởng. Vui lòng liên hệ đội ngũ RENEC để được trợ giúp.",
        claim_reward: "Lỗi khi nhận thưởng. Vui lòng liên hệ đội ngũ RENEC để được trợ giúp.",
        fetch_bte_reward: "Lỗi khi lấy dữ liệu thưởng khi vay. Vui lòng liên hệ đội ngũ RENEC để được trợ giúp.",
      },
      my_account: "Tài sản của tôi",
      borrow_limits: "Tình trạng khoản vay",
      subtitle_borrow_limits: "Tỉ lệ đã vay trên tổng kí gửi của bạn.",
      others: "Tài sản khác",
      my_staking: "Staking của tôi",
      stake_and_earn: "Stake & Earn",
      total_nft_voucher: "Tổng NFT voucher",
      nft_view_detail: "Chi tiết",
      nft_voucher: "vouchers",
      nft_claim: "Nhận thưởng",
      title_nft_vouchers: "NFT Vouchers",
      available_to_claim_tab: (amount: number) => `Có thể nhận (${amount})`,
      claimed_tab: (amount: number) => `Đã nhận (${amount})`,
      available_to_claim: (amount: number) =>
        `(Có thể nhận thưởng: <span class="font-semibold text-neutral-900">${amount}</span>)`,
      claim_now: "Nhận ngay",
    },
    table: {
      asset: "Tài sản",
      supplied: "Đã kí gửi",
      price_change: "Giá thay đổi",
      supply: "Kí gửi",
      market_price: "Giá",
      supply_apy: "Lãi suất kí gửi (APY)",
      wallet_balance: "Số dư trong ví",
      earned: "Kiếm được",
      actions: "Hành động",
      borrowed: "Đã vay",
      borrow_apr: "Lãi suất vay (APR)",
      borrow_apy: "Lãi suất vay (APY)",
      interest: "Lãi cần trả",
      withdraw: "Rút",
      borrow: "Vay",
      repay: "Trả nợ",
      detail: "Chi tiết",
      my_supply: "Kí gửi của tôi",
      my_borrow: "Vay của tôi",
      your_borrow_limit: "Hạn mức của bạn",
      ltv: "LTV",
      ltv_info: "LTV là tỷ lệ xác định mức độ vay được đóng góp bởi một tài sản ký gửi.",
      empty_supply: "Bạn chưa kí gửi token nào",
      empty_borrow: "Bạn chưa có khoản vay nào",
      total_supply: "Tổng kí gửi",
      supplied_info: "Tổng ký gửi bao gồm số token cho vay và lãi nhận được",
      supply_apy_interest: "Lãi kí gửi",
      rewards: "thưởng",
      max_reward: "Tổng thưởng: ",
      supply_reward_information: "Thông tin về phần thưởng này có thể được tìm thấy tại",
      temp_ngn_borrow_apr_info:
        "Do sự lạm phát cao tại Nigeria, lãi vay sẽ được điều chỉnh tương ứng để cân bằng quyền lợi giữa người kí gửi và người vay",
      no_liquidations: "Hiện tại đang không có khoản vay nào cần được thanh lý.",
      here: "đây",
      your_wallet_empty: (network: string, isRenecChain: boolean, bridgeName?: string, bridgeLink?: string) => (
        <Typography className='text-xs'>
          {isRenecChain ? (
            <>
              Ví {network} của bạn trống. Mua hoặc chuyển tài sản bằng{" "}
              <Link href={bridgeLink} target='_blank' className='font-bold' rel='noreferrer'>
                {bridgeName}
              </Link>{" "}
            </>
          ) : (
            <>
              Ví {network} của bạn trống. Mua hoặc chuyển tài sản hoặc sử dụng{" "}
              <Link href={bridgeLink} target='_blank' className='font-bold' rel='noreferrer'>
                {bridgeName}
              </Link>{" "}
              để chuyển tài sản ở mạng {network} của bạn
            </>
          )}
        </Typography>
      ),
      borrow_no_obligation: (
        <Typography className='text-xs'>
          Để vay, bạn cần cung cấp một tài sản để sử dụng làm tài sản thế chấp.
        </Typography>
      ),
      refresh_reward_tooltip_desc: (timeleft: string) =>
        `Phần thưởng của bạn sẽ tự động làm mới sau ${timeleft}. Nhấn vào đây để làm mới thủ công.`,
      refresh_ste_reward_successfully: "Tổng phần thưởng của bạn đã được cập nhật.",
      errors: {
        fetch_ste_reward: "Lỗi khi lấy dữ liệu thưởng khi kí gửi. Vui lòng liên hệ đội ngũ RENEC để được trợ giúp.",
      },
      info: {
        price_change: "Giá thay đổi trong 24 giờ qua",
      },
      isolated: "Isolated",
      isolated_desc:
        "Isolated là tài sản được tách riêng, sẽ không ảnh hưởng đến giới hạn vay và khả năng bị thanh lý của bạn",
    },
    ad: {
      title: "Relend Earn",
      subtitle: "Kiếm lời ổn định với cách quản lý tài sản chuyên nghiệp",
      total_borrowed: "Tổng lượng vay",
      apy_fixed_rate: "Tỉ lệ vay APR, lãi cố định",
      claim_now: "Nhận ngay",
    },
    modal: {
      supply: "Kí gửi",
      withdraw: "Rút tiền",
      repay: "Trả nợ",
      borrow: "Vay",
      max: "Tối đa",
      balance: "Số dư:",
      in_wallet: "trong ví",
      market_price: "Giá",
      supply_apy: "Lãi suất kí gửi (APY)",
      your_supply_limit: "Mức kí gửi tối đa của bạn",
      borrow_utilization: "Tỉ lệ vay/vốn",
      your_total_supply: "Tổng kí gửi của bạn",
      borrow_apr: "Lãi suất vay (APR)",
      borrow_fee: "Phí vay",
      your_total_borrow: "Tổng tài sản đã vay",
      your_total_borrow_limit: "Hạn mức vay của bạn",
      liquidation_threshold: "Ngưỡng thanh lý",
      successfully: "thành công",
      view_transaction: "Bấm vào đây để xem giao dịch",
      enter_amount: "Nhập số tiền",
      growth_hacking_desc: "Tính năng này sẽ được hỗ trợ trong thời gian sắp tới. Hãy quay lại sau nhé!",
      happy_pi_day: "Chúc mừng ngày quốc tế số Pi 14/03",
      no_supply_collateral: "Bạn chưa cung cấp bất kỳ tài sản thế chấp nào",
      no_supply_reserve: "Bạn chưa cung cấp bất kỳ %s nào",
      loading: "Đang tải...",
      updating: "Đang cập nhập...",
      supply_apy_tooltip:
        "Lãi suất APY (tỉ lệ lãi hàng năm) là số tiền lãi từ người dùng mượn tài sản của bạn khi bạn cung cấp tài sản trên nền tảng. Lãi suất APY được chia đều cho toàn bộ pool. Ví dụ, nếu trong một pool có 2 BTC, và 1 BTC được cho vay với lãi suất APY 20%, thì những người cung cấp 2 BTC sẽ nhận được lãi suất APY 10% mỗi người",
      borrow_apr_tooltip:
        "Lãi suất cho vay APR là tỉ lệ phần trăm hàng năm mà người vay phải trả cho khoản vay. Nó được tính toán dựa trên lãi suất của khoản vay",
      borrow_fee_tooltip: "Phí cần phải trả khi tạo khoản vay",
      borrow_utilization_tooltip:
        "Tỷ lệ sử dụng hạn mức vay biểu thị bao nhiêu phần trăm giới hạn vay của bạn. Tỷ lệ sử dụng được tính bằng Số Token bạn Vay / Số Token bạn Cung Cấp",
      total_borrow_limit_tooltip: "Tổng giá trị của các token mà người dùng có thể vay trên toàn nền tảng",
      liquidation_threshold_tooltip:
        "Ngưỡng thanh lý là giá trị tối đa của các khoản vay của bạn trước khi tài khoản của bạn có thể bị thanh lý. Đây là một tình huống không tốt và nên tránh bằng cách giảm tỷ lệ khoản vay của bạn. Giới hạn này được tính toán dựa trên số tiền bạn đã gửi và số tiền bạn đã vay",
      your_max_supply_tooltip: "Giá trị tối đa của các token mà bạn có thể cung cấp trên toàn bộ nền tảng",
      your_total_borrow_tooltip: "Tổng giá trị của các token bạn đã mượn trên toàn bộ nền tảng",
      your_total_supply_tooltip: "Tổng giá trị của các token bạn đã cung cấp trên toàn bộ nền tảng",
      supply_successfully: "Kí gửi thành công",
      borrow_successfully: "Vay thành công",
      withdraw_successfully: "Rút tiền thành công",
      repay_successfully: "Thanh toán thành công",
      liquidate_successfully: "Thanh lý thành công",
      you_just_supplied: "Bạn vừa nạp",
      you_just_borrowed: "Bạn vừa vay",
      you_just_withdrawed: "Bạn vừa rút tiền",
      you_just_repaid: "Bạn vừa thanh toán",
      you_just_liquidated: "Bạn vừa thanh lý",
      view_tx: "Xem giao dịch",
      go_home: "Về trang chủ",
      close: "Đóng",
      free_borrow_fee: "(MIỄN PHÍ)",
      so: "Số",
      borrowed: "đã vay",
      interest_to_pay: "Lãi cần trả",
      total_amount_repay: (symbol: string) => `Tổng ${symbol} cần trả`,
      not_enough_balance: "Số dư không đủ. Xem cách nạp",
      not_enough_balance_link: "https://renec.org/blog/huong-dan-nap-token",
      not_enough_balance_solana_token_link: (tokenMint: string) =>
        tokenMint === USDC
          ? `https://jup.ag/swap/SOL-USDC`
          : tokenMint === SOL
            ? `https://jup.ag`
            : `https://jup.ag/swap/USDC-${tokenMint}`,
      how_to_withdraw: "Hướng dẫn rút VND về ngân hàng",
      how_to_withdraw_link: "https://renec.org/vi/blog/huong-dan-vay-tra-no-revnd",
      withdraw_to_bank: "Rút về ngân hàng",
      congrats: "Chúc mừng",
      oops: "Oops!",
      ok: "Ok",
      choose_nft_for_promotion: "Chọn NFT để giảm giá",
      select_nft: "Chọn NFT",
      choose_nft_to_send: "Chọn NFT để gửi",
      choose_nft: "Chọn NFT",
      search_by_name_or_address: "Tìm kiếm theo tên hoặc địa chỉ",
      change_nft: "Đổi NFT",
      choose_nft_error: "Không thể áp dụng NFT này. Vui lòng chọn một NFT khác.",
      no_nft_to_send: "Không tìm thấy NFT để gửi",
      nft_address: "Địa chỉ:",
      nft_promotion: (discount: number, maxDiscount: number) => `Giảm ${discount}% - Tối đa $${maxDiscount}`,
      nft_detail: "Thông tin NFT",
      nft_description: "Mô tả",
      nft_more_info: "Thông tin thêm",
      nft_more_info_start_date_end_date: "Ngày bắt đầu - Ngày kết thúc",
      nft_more_info_discount_percentage: "Phần trăm giảm giá",
      nft_more_info_eligible_token: "Token đủ điều kiện",
      nft_more_all_token: "Tất cả token",
      show_more: "Xem thêm",
      show_less: "Rút gọn",
      claim_your_reward: "Nhận Phần Thưởng",
      claim_your_reward_desc: (symbol: string) => `Bạn có muốn nhận toàn bộ phần thưởng ${symbol} của bạn không?`,
      claim_confirm: "Nhận thưởng",
      claim_later: "Để sau",
      confirm: "Xác nhận",
      claim_successfully: "Thành công",
      you_have_claimed_successfully: (rewardSymbol: string) => (
        <>
          Bạn đã nhận tất cả phần thưởng{" "}
          <Typography component='span' fontWeight={700}>
            {rewardSymbol}
          </Typography>{" "}
          thành công
        </>
      ),
      claim_you_got: "Bạn đã nhận được",
      claim_nft_voucher: "Nhận NFT voucher",
      claim_nft_voucher_desc: "Bạn có muốn nhận về 1 NFT voucher không?",
      claim_nft_voucher_successfully: "Bạn đã nhận NFT voucher thành công",
      exclusive_gift_for_you: "Quà tặng đặc biệt dành cho bạn",
      exclusive_gift_for_you_desc: (
        <>
          Chúc mừng! Bạn đã nhận được <span className='font-semibold text-base text-[#F7931A]'>1 NFT voucher</span>
        </>
      ),
      get_it_now: "Nhận ngay",
      errors: {
        max_positions_reached: "Đã đạt giới hạn vị thế tối đa",
        over_reserve_deposit_limit: "Quá giới hạn dữ trữ tiền gửi",
        insufficient_balance: (tokenSymbol?: string) =>
          tokenSymbol ? `Số dư ${tokenSymbol} không đủ` : "Số dư không đủ",
        min_native_fee: "Bạn cần nạp thêm %s %s để trả phí",
        insufficient_renec_balance: "Không đủ RENEC để thực hiện giao dịch",
        please_enter_amount: "Nhập số tiền",
        insufficient_liquidity_borrow: "Không đủ thanh khoản để vay",
        over_reserve_borrow_limit: "Quá giới hạn vay dự trữ",
        cannot_borrow_utilization: "Không thể vay nếu hiệu suất sử dụng vượt quá 95%",
        exceeds_borrow_limit: "Vượt quá giới hạn vay",
        pool_outflow_rate_limit: "Vượt quá tỉ lệ giới hạn dòng vốn ra của quỹ",
        reserve_outflow_rate_limit: "Vượt quá tỉ lệ giới hạn dòng ra dự trữ của quỹ",
        insufficient_liquidity_withdraw: "Không đủ thanh khoản để rút",
        cannot_withdraw_limit: "Không thể rút hơn giới hạn rút",
        cannot_withdraw_under_collateralization: "Không thể rút khoản đang được thế chấp",
        amount_exceeded_borrowed: "Số tiền vượt quá số lượng đã vay",
        failed_to_complete: "Không thể thực hiện giao dịch",
        please_use_gasless:
          "Cần ít nhất 0.02 RENEC cho phí giao dịch và các phí liên quan. Hãy sử dụng tính năng gasless hoặc nạp thêm RENEC để thực hiện giao dịch",
        need_renec_for_transaction_fee:
          "Cần ít nhất 0.000005 RENEC cho phí giao dịch. Hãy sử dụng tính năng gasless hoặc nạp thêm RENEC để thực hiện giao dịch",
        need_sol_for_transaction_fee: "Cần ít nhất 0.02 SOL cho phí giao dịch. Hãy nạp thêm SOL để thực hiện giao dịch",
        deposit_more_token: "Nạp thêm %s",
        deposit_more_renec: "Nạp thêm RENEC",
        deposit_more_sol: "Nạp thêm SOL",
        failed_to_liquidate: "Thanh lý khoản vay thất bại",
        gasless_updating: "Dịch vụ gasless đang được cập nhật. Vui lòng sử dụng giao dịch thông thường",
        reduce_positions:
          "Số vị thế Kí gửi và Vay đã đạt tối đa. Vui lòng hãy giảm số vị thế hoặc dùng ví khác để kí gửi/vay token này",
        tx_too_large:
          "Giao dịch của bạn quá lớn. Vui lòng giảm bớt các vị trí đang kí gửi/cho vay của bạn hoặc chuyển sang ví khác và thử lại.",
        not_enough_ste_fund: "Phần thưởng đã hết. Hãy theo dõi RENEC Lend để đón chờ những sự kiện sắp tới",
      },
      usds_notice: {
        title: "Thông Báo Rút USDS",
        message:
          "Xin lưu ý việc rút USDS trước 04/01/2025 sẽ chỉ bao gồm số tiền gửi ban đầu. Phần thưởng sẽ chỉ có thể rút được sau ngày 04/01/2025",
      },
    },
  },
  referral: {
    empty: {
      not_qualified: "Bạn không đủ điều kiện để nhận phần thưởng",
      please_buy_rel: "Vui lòng mua token REL để tiếp tục",
      buy_rel: "Mua REL",
    },
    hero: {
      title: "Mời bạn bè và kiếm phần thưởng",
      sub_title: "Mời bạn bè tham gia cùng chúng tôi, cả hai bạn sẽ có cơ hội nhận những ưu đãi độc quyền.",
      connect_wallet: "Kết nối Ví",
      copy_link: "Sao chép",
      copied: "Đã sao Chép",
      your_referrer: "Người giới thiệu của bạn",
      view_detail: "Xem chi tiết",
    },
    detail: {
      title: "Chi tiết chương trình giới thiệu",
      desc_1: "Để đủ điều kiện, bạn cần giữ token REL, kết nối ví của mình và chia sẻ liên kết giới thiệu của bạn",
      desc_2:
        "Khi người dùng mới kết nối ví của họ với RENEC Lend qua liên kết của bạn, họ sẽ được đánh dấu là người được giới thiệu bởi bạn",
      desc_3:
        "Sau đó, mỗi khi người được giới thiệu của bạn vay tiền, bạn sẽ nhận được 20% phí vay mà họ trả, mà không tốn thêm chi phí nào cho họ",
      overview: "Tổng Quan",
      bonus_you_got: "Phần thưởng bạn đã nhận",
      have_been_invited: "Đã mời",
      friends: "Bạn bè",
      no_bonus: "Không có thưởng thêm",
      borrow_now: "Vay Ngay",
      connect_wallet_to_view: "Kết nối ví để xem phần thưởng của bạn!",
      detail: "Chi tiết:",
      how_to_refer: "Cách tham gia",
      show_more: "Xem thêm",
      show_less: "Rút gọn",
    },
    table: {
      reward_history: "Lịch Sử Thưởng",
      timestamp: "Thời Gian",
      referred: "Người Được Giới Thiệu",
      asset: "Tài Sản",
      reward_earned: "Phần Thưởng Đã Kiếm Được",
      tx_detail: "Chi Tiết Giao Dịch",
      no_data: "Không có Dữ Liệu",
      load_more: "Load more",
    },
  },
  liquidations: {
    liquidation_position: "Khoản vay thanh lý",
    choose_position_liquidate: "Chọn vị thế để thanh lý khoản vay",
    table: {
      position_id: "ID vị thế",
      loan_token: "Token vay",
      collateral_token: "Token thế chấp",
      collateral_amount: "Số lượng thế chấp",
      need_to_pay: "Cần phải trả",
      liquidate: "Thanh lý",
      actions: "Hành động",
    },
  },
  staking: {
    hero: {
      stake_earn_grow: "Stake & Earn: gia tăng",
      craft_your: "định hình tương lai.",
      relend: "Relend",
      rel: "REL",
      shape_future: ", định hình tương lai.",
      rel_holders: "Những người nắm giữ REL",
      description_p1_1: "Người dùng có thể",
      description_p1_2:
        "của mình vào Secure Vault để tăng thêm tính bảo mật cho giao thức và kiếm thêm phần thưởng. Trong trường hợp xảy ra sự cố, RENEC Foundation sẽ vay một khoản tiền từ vault để trang trải khoản thất thoát, giúp bảo vệ cho giao thức.",
      description_p2:
        "Ngoài ra, bằng cách staking REL, bạn có thể tham gia vào việc quản trị giao thức. Số lượng token được stake sẽ ảnh hưởng đến phiếu bầu của bạn đối với các đề xuất cho giao thức RENEC Lend",
      stake_rel: "stake REL",
      learn_more: "Tìm hiểu thêm",
      learn_more_link: "https://renec.org/vi/blog/tinh-nang-stake-rel",
      total_staked_rel: "Tổng REL trong Secure Vault",
      total_reward_per_day: "Tổng phần thưởng mỗi ngày",
      total_reward_per_day_tooltip: "Số phần thưởng sẽ phân phối mỗi ngày cho các Relend staker",
      staking_apy: "Staking APY",
    },
    detail: {
      my_assets: "Tài sản của tôi",
      my_staking_reward: "Phần thưởng của tôi",
      rel_wallet_balance: "Số dư REL trong ví",
      your_verel: "veREL trong ví",
      stake: "Stake",
      unstake: "Unstake",
      start_unstake: "Bắt đầu chờ unstake",
      withdraw: "Rút",
      convert: "Chuyển đổi",
      my_rel_staking: "REL Staking",
      cooldown_period: "Thời gian chờ",
      total_staked_rel: "Tổng REL đã stake",
      total_claimable_verel: "Tổng veREL có thể nhận",
      unstaking: "Unstaking",
      stop_unstake: "Dừng unstake",
      claim: "Nhận",
      what_is_verel: "veREL là gì?",
      what_is_verel_link: "https://renec.org/vi/blog/tinh-nang-stake-rel",
      cooldown_tooltip_1:
        "Khi bắt đầu unstake, thời gian chờ sẽ được kích hoạt. Thời gian chờ này sẽ dựa vào số REL được unstake:",
      cooldown_tooltip_2: "Ít hơn 1,000,000 REL: 7 ngày (168 giờ)",
      cooldown_tooltip_3: "Lớn hơn hoặc bằng 1,000,000 REL: 14 ngày (336 giờ)",
      cooldown_tooltip_4: "Trong thời gian chờ, bạn vẫn có thể stake thêm REL và khi đó, thời gian này sẽ bị hủy",
      connect_wallet_to_view_reward: "Kết nối ví để xem tất cả phần thưởng của bạn!",
    },
    modal: {
      staking: "Staking",
      unstaking: "Unstaking",
      estimate_reward: "Ước tính phần thưởng của bạn mỗi ngày",
      staking_apy: "Staking APY",
      estimate_cooldown: "Ước tính thời gian chờ của bạn",
      days: "ngày",
      hours: "giờ",
      stake: "Stake",
      unstake: "Unstake",
      are_you_sure: "Bạn có chắc muốn nhận",
      are_you_sure_stop_unstake: "Bạn có chắc muốn dừng việc unstake",
      stop_unstaking: "Dừng unstake",
      cancel: "Hủy",
      claim: "Nhận",
      stop: "Dừng",
      withdraw: "Rút",
      in_wallet: "trong ví",
      staked: "đã stake",
      just_staked: "Bạn vừa stake thành công.",
      just_start_unstaking: "Bạn vừa bắt đầu unstake thành công.",
      stop_unstaking_token_successfully: "Bạn vừa dừng unstaking thành công.",
      claim_reward_token_successfully: "Bạn vừa nhận phần thưởng thành công.",
      stake_successfully: "Stake thành công",
      unstake_successfully: "Unstake thành công",
      stop_unstaking_successfully: "Dừng unstake thành công",
      withdraw_successfully: "Rút thành công",
      claim_reward_successfully: "Nhận thưởng thành công",
      you_just_staked: "Bạn vừa staked",
      you_just_unstaked: "Bạn vừa unstaked",
      you_just_stop_unstaked: "Bạn vừa ngừng việc unstake",
      you_just_withdraw: "Bạn vừa rút ",
      you_just_claim_reward: "Bạn vừa nhận thưởng",
      confirm: "Xác nhận",
      claim_verel: "Nhận veREL",
    },
    errors: {
      failed_to_fetch_reward_token_account_info:
        "Lỗi khi lấy dữ liệu phần thưởng token. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin hoặc thử lại.",
      stake: "Lỗi khi stake token. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin.",
      unstake: "Lỗi khi bắt đầu unstaking. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin.",
      fetch_bte_reward: "Lỗi khi lấy dữ liệu phần thưởng vay. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin.",
      please_enter_amount: "Vui lòng nhập số tiền",
      not_enough_balance: "Không đủ số dư",
      cannot_unstake_above_staked_amount: "Không thể unstake vượt quá số tiền đã stake",
      withdraw_staking_token:
        "Lỗi khi rút token stake. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin hoặc thử lại.",
      claim_reward_token: "Lỗi khi nhận token thưởng. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin hoặc thử lại.",
      stop_unstaking: "Lỗi khi dừng unstaking. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin hoặc thử lại.",
      stake_unstake:
        "Lỗi khi staking/unstaking token. Vui lòng liên hệ nhóm RENEC để biết thêm thông tin hoặc thử lại.",
      failed_to_complete: "Không thể thực hiện giao dịch",
      deposit_more_renec: "Nạp thêm RENEC",
      please_deposit_renec:
        "Cần ít nhất %s RENEC cho phí giao dịch và các phí liên quan. Hãy nạp thêm RENEC để thực hiện giao dịch",
    },
  },
  common: {
    tx_hash: "Mã giao dịch: ",
    sorry_feature_developing: "Tính năng này đang được phát triển. Vui lòng quay lại sau!",
    feature_under_development: "Chức năng đang phát triển",
    ok: "Ok",
    come_back_later: "Quay lại sau",
    search_token: "Tìm kiếm token",
    token_picker_no_tokens_found: "Không tìm thấy token nào",
    token_picker_please_select: "Chọn token...",
    notification: "Thông báo",
    cancel: "Hủy",
    confirm: "Xác nhận",
  },
  wallet: {
    copied: "Đã copy",
    copy_address: "Copy địa chỉ",
    connect_wallet: "Kết nối ví",
    change_wallet: "Thay đổi ví",
    connecting: "Đang kết nối...",
    select_wallet: "Chọn ví",
    disconnect: "Ngắt kết nối",
  },
  errors: {
    go_back_home: "Về trang chủ",
    error_404: "404 - Không tìm được trang",
    error_500: "500 - Đã xảy ra lỗi phía máy chủ",
    system_error: "Hệ thống đang cập nhật. Xin quay lại sau",
    deny_transaction: "Người dùng từ chối giao dịch.",
    default_error: "Lỗi khi thực hiện giao dịch. Hãy thử lại sau.",
  },
}

export default locale
